module.exports = __webpack_public_path__ + "img/img-vechain-tm@2x.adc38de4.png";